<template>
<common-dialog
  :show.sync="visible"
  :title="title"
  class="address-dialog"
>
  <div class="dialog-body">
    <el-form :model="dataModel" ref="dataForm" :rules="rules" label-width="91px">
      <el-form-item label="姓名" prop="addressee">
        <el-input
          type="text"
          v-model.trim="dataModel.addressee"
          placeholder="请输入姓名"
          :maxlength="15"
        ></el-input>
      </el-form-item>

      <el-form-item label="电话" prop="mobile_phone">
        <el-input
          type="text"
          v-model.trim="dataModel.mobile_phone"
          placeholder="请填写手机号"
          :maxlength="11"
        ></el-input>
      </el-form-item>

      <el-form-item label="地址" class="is-required region-combine">
        <el-select
          v-model="dataModel.province_code"
          placeholder="省"
          @change="dataModel.city_code = ''"
        >
          <el-option
            :label="v"
            :value="k"
            v-for="(v, k) in pcds[86]"
            :key="k"
          ></el-option>
        </el-select>

        <el-select
          v-model="dataModel.city_code"
          placeholder="市"
          @change="dataModel.county_code = ''"
        >
          <el-option
            :label="v"
            :value="k"
            v-for="(v, k) in pcds[dataModel.province_code]"
            :key="k"
          ></el-option>
        </el-select>

        <el-select v-model="dataModel.county_code" placeholder="区">
          <el-option
            :label="v"
            :value="k"
            v-for="(v, k) in pcds[dataModel.city_code]"
            :key="k"
          ></el-option>
        </el-select>

        <transition name="scaleY">
          <div class="el-form-item__error" v-if="!pcdValid && submitted">
            请选择省市区
          </div>
        </transition>
      </el-form-item>

      <el-form-item prop="detail_address">
        <el-input
          type="text"
          v-model.trim="dataModel.detail_address"
          placeholder="详细地址"
          :maxlength="50"
        ></el-input>
      </el-form-item>

      <el-form-item label="智能地址填写" class="recognition-box">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 6 }"
          v-model.trim="adderssFillingContent"
          placeholder="粘贴或输入一整段地址信息，点击“智能填写”识别姓名、电话和地址。例如：张三，15999697713，广东省深圳市南山区科兴A1"
          :maxlength="100"
        ></el-input>
        <div class="clear-recognition-text" v-if="adderssFillingContent && adderssFillingContent.length >= 7" @click="adderssFillingContent = ''">
          清空
        </div>
        <div class="intelligent-recognition" v-if="adderssFillingContent && adderssFillingContent.length >= 7" @click="recognitionAddress">
          智能填写
        </div>
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input
          type="text"
          v-model.trim="dataModel.email"
          placeholder="此邮箱用于接收面试通知书、电子签证等重要信息"
          :maxlength="50"
        ></el-input>
      </el-form-item>

      <el-form-item prop="is_default" v-if="showSetDefault">
        <el-checkbox
          label="设为默认收货地址"
          name="is_default"
          v-model="dataModel.is_default"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
      </el-form-item>
    </el-form>
  </div>
  <div class="staff-dialog-footer" slot="footer">
    <slot name="other-btn"></slot>
    <button v-if="!hideCancelBtn" @click="visible = false" class="s-btn btn-info btn-lg">取消</button>
    <button @click="formSubmit" class="s-btn btn-blue btn-lg">保存</button>
  </div>
</common-dialog>
</template>

<script>
import CommonDialog from '../common/modals/common-dialog/common-dialog.vue';
import validates from '../../libs/validates';
import utils from '../../libs/utils';
import pcdService from '../../services/pcd-service';
import addressService from '../../services/address-service';

export default {
  components: {
    CommonDialog,
  },
  props: {
    title: {
      type: String,
      default: '修改地址',
    },
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    addressInfo: Object,
    showSetDefault: {
      type: Boolean,
      default: false,
    },
    hideCancelBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      dataModel: {
        addressee: '', // 联系人
        mobile_phone: '', // 手机号
        email: '', // 邮箱
        province_code: '', // 省
        city_code: '', // 市
        county_code: '', // 区
        detail_address: '', // 详细地址
        is_default: 0, // 设置默认
      },
      adderssFillingContent: '', // 智能地址填写内容
      pcds: {},
      submitted: false, // 表单是否提交
      rules: {
        addressee: [validates.required('姓名'), validates.range(15, 2, '姓名')],
        mobile_phone: [validates.required('电话'), validates.mobile('电话')],
        email: [validates.required('邮箱'), validates.email('邮箱')],
        detail_address: [validates.required('详细地址')],
      },
    };
  },
  computed: {
    // 省市区是否合法
    pcdValid() {
      if (this.dataModel.city_code && this.pcds[this.dataModel.city_code]) {
        return (
          this.dataModel.province_code &&
          this.dataModel.city_code &&
          this.dataModel.county_code
        );
      }
      return this.dataModel.province_code && this.dataModel.city_code;
    },
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
      if (val) {
        this.init();
      }
    },
  },
  created() {
    this.getPcdData();
  },
  methods: {
    init() {
      this.$refs.dataForm && this.$refs.dataForm.resetFields();
      this.submitted = false;
      this.adderssFillingContent = '';
      if (this.addressInfo) {
        this.dataModel = utils.extend({}, this.dataModel, this.addressInfo, {
          province_code: this.addressInfo.province_code && this.addressInfo.province_code.toString(),
        });
        // 分步赋值，不然容易渲染不出来
        this.$nextTick()
          .then((vm) => {
            this.dataModel.city_code = this.addressInfo.city_code.toString();
            return vm.$nextTick();
          })
          .then((vm) => {
            this.dataModel.county_code = this.addressInfo.county_code > 0 ? this.addressInfo.county_code.toString() : '';
            return vm.$nextTick();
          });

      } else {
        this.dataModel = {
          addressee: '', // 联系人
          mobile_phone: '', // 手机号
          email: '', // 邮箱
          province_code: '', // 省
          city_code: '', // 市
          county_code: '', // 区
          detail_address: '', // 详细地址
          is_default: 0, // 设置默认
        };
      }
    },
    // 获取省市区数据
    getPcdData() {
      pcdService
        .getPcd()
        .then(pcds => (this.pcds = pcds))
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    // 识别地址
    recognitionAddress() {
      addressService
        .recognizeAddress(this.adderssFillingContent)
        .then((data) => {
          this.intelligentFillAddress(data);
          utils.msg.success('智能填写成功');
        })
        .catch((err) => {
          console.log(err);
          utils.msg.error(err.msg);
        });
    },
    // 处理特殊的区code
    parseCountyCode(addressParseData) {

      // 至少要识别到省和市才处理
      if (addressParseData.province_code && addressParseData.city_code) {
        const result = {
          province_code: addressParseData.province_code,
          city_code: addressParseData.city_code,
        };

        // 如果该地区有区
        if (this.pcds[addressParseData.city_code]) {

          // 如果识别到了区
          if (addressParseData.county_code) {
            result.county_code = addressParseData.county_code;
            return result;
          }

          // 没有识别到区，就全部数据不要
          return {};
        }

        // 如果该地区没有有区
        result.county_code = '';
        return result;
      }

      // 没有识别到就直接返回空
      return {};
    },
    // 智能设置地址
    intelligentFillAddress(res) {

      const parsedPcdsData = this.parseCountyCode(res);

      // 要合并的地址原始对象
      const mergeAddress = {
        addressee: res.name ? res.name : this.dataModel.addressee,
        mobile_phone: res.mobile ? res.mobile : this.dataModel.mobile_phone,
        detail_address: res.detail ? res.detail.trim() : this.dataModel.detail_address,
      };

      // 如果有省才加入省字段
      if (parsedPcdsData.province_code) {
        mergeAddress.province_code = parsedPcdsData.province_code;
      }

      // 先设置其他属性
      this.dataModel = Object.assign({}, this.dataModel, mergeAddress);

      // 在设置别的属性
      if (parsedPcdsData.province_code) {

        // 依次设置地址省市区
        this.$nextTick()
          .then((vm) => {
            vm.dataModel.city_code = parsedPcdsData.city_code;
            return vm.$nextTick();
          })
          .then((vm) => {
            vm.dataModel.county_code = parsedPcdsData.county_code;
          });
      }
    },
    // 表单提交
    formSubmit() {
      this.submitted = true;
      this.$refs.dataForm.validate((valid) => {
        if (valid && this.pcdValid) {
          const postData = utils.extend({}, this.dataModel);

          postData.province_code = +postData.province_code;
          postData.city_code = +postData.city_code;
          postData.county_code = Number(postData.county_code) || 0;

          this.$emit('success', postData);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.address-dialog{
  /deep/ .el-dialog{
    width: 600px;
  }
}
.dialog-body{
  padding: 24px 24px 4px 24px;
  /deep/ .el-form-item{
    .el-form-item__label{
      color: #2F333D;
      font-size: 14px;
      line-height: 20px;
      padding: 10px 10px 10px 0;

      &::after{
        content: '*';
        color: #fff;
        margin-left: 4px;
        font-weight: 400;
      }
    }
    &.is-required{
      .el-form-item__label{
        &::before{
          display: none;
        }
        &::after{
          color: #FF6464;
        }
      }
    }
  }
  /deep/ .el-input__inner{
    height: 40px;
    border-radius: 2px;
    color: #2F333D;
    font-size: 14px;
  }

  .region-combine{
    /deep/ .el-form-item__content {
      display: flex;
      .el-select{
        flex: 1;
        margin-right: 12px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  .recognition-box{
    /deep/ .el-form-item__label{
      padding-right: 20px;
      &::after{
        display: none;
      }
    }
    .clear-recognition-text {
      position: absolute;
      right: 80px;
      bottom: 14px;
      line-height: 1;
      color: #aaa;
      font-size: 14px;
      cursor: pointer;
    }
    .intelligent-recognition {
      position: absolute;
      right: 12px;
      bottom: 14px;
      line-height: 1;
      color: #599fff;
      font-size: 14px;
      cursor: pointer;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/address/add-or-edit-address-dialog.vue